const ROADMAP_ITEMS = [
    {
        done: true,
        title: 'Antal personer online',
    },
    {
        done: true,
        title: 'Autofokus på sökfältet',
    },
    {
        done: true,
        title: 'Visa personer i mötesrum',
    },
    {
        done: false,
        title: 'Pinna kollegor',
    },
    {
        done: false,
        title: 'Mer information om mötesrummen',
    },
    {
        done: false,
        title: 'Är vattnet varmt i vattenkokaren?',
    },
    {
        done: false,
        title: 'Se flera dagar framåt',
    },
    {
        done: false,
        title: 'Visa återkommande vs enstaka möten',
    },
];

const SORTED_ROADMAP_ITEMS = [ ...ROADMAP_ITEMS ].sort( ( a, b ) => {
    return ( b.done ? 1 : 0 ) - ( a.done ? 1 : 0 );
} );

function Roadmap() {
    const doneCount = ROADMAP_ITEMS.filter((item) => item.done).length;

    return (
        <div className="roadmap">
            <div className="roadmap-header">
                <h2>Roadmap</h2>
                <p className="roadmap-progress">
                    { `${ doneCount } av ${ ROADMAP_ITEMS.length } klara` }
                </p>
            </div>
            <ul className="roadmap-list">
                { SORTED_ROADMAP_ITEMS.map((item) => (
                    <li
                        key = { item.title }
                        className = { `roadmap-item${ item.done ? ' roadmap-item-done' : '' }` }
                    >
                        <span
                            className = { 'roadmap-checkbox' }
                            aria-hidden = { 'true' }
                        >
                            { item.done ? '✓' : '' }
                        </span>
                        <span className="roadmap-item-title">{ item.title }</span>
                    </li>
                )) }
            </ul>
        </div>
    );
}

export default Roadmap;
